import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import { ServiceIntegrationPartner } from './types';

export const partnerAtom = atomWithReset<ServiceIntegrationPartner | null>(null);

export const editIntegrationAtom = atomWithReset<{
  configId: number | null;
}>({ configId: null });

export const createIntegrationAtom = atomWithReset(false);

export const SubscriptionAtom = atomWithReset(false);

export const isEditCreateFormOpenAtom = atom((get) => {
  const editId = get(editIntegrationAtom).configId;
  const createFlag = get(createIntegrationAtom);

  return !!editId || createFlag;
});
